import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

const claimTaskReq = (assignee: string, taskIds: string[], tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.claimTask),
    method: 'POST',
    cache: false,
    body: { assignee: assignee, applicationIds: taskIds },
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { claimTaskReq }
